import { lireDate as lire } from "./rdv";
// Article : sommaire depuis les titres, rubrique parente dans le fil d'Ariane,
// prochain rendez-vous à venir, copie du lien, impression.
// Fil d'Ariane : sur les articles et les pages de rubrique, on cherche dans la navigation de l'en-tête
// la sous-rubrique la plus profonde portée par la page, puis sa rubrique parente.
function filAriane() {
    const feuille = document.querySelector("[data-crumb-tag]");
    if (!feuille) return;
    const chemin = (u) => new URL(u, location.origin).pathname.replace(/\/+$/, "");
    const enfants = new Map([...document.querySelectorAll("#nav-primary .sub a")].map((a) => [chemin(a.getAttribute("href")), a]));
    // Candidats : les tags de l'article (pastilles), puis le tag principal
    const candidats = [chemin(feuille.dataset.crumbTag), ...[...document.querySelectorAll(".tags a")].map((a) => chemin(a.getAttribute("href")))];
    const lien = candidats.map((c) => enfants.get(c)).find(Boolean);
    // Référence hors menu : on remonte à l'entrée de menu de sa collection (« La commune »)
    const collection = !lien && feuille.dataset.crumbCollection && [...document.querySelectorAll("#nav-primary .nav-link")].find((a) => chemin(a.getAttribute("href")) === chemin(feuille.dataset.crumbCollection));
    const parent = lien ? lien.closest(".nav-item")?.querySelector(":scope > .nav-link") : collection;
    if (!parent) return;
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = parent.href;
    a.textContent = parent.textContent.trim();
    li.appendChild(a);
    feuille.before(li);
    const navPage = feuille.closest("[data-crumb-page]");
    if (navPage) navPage.hidden = false;
    // Si la feuille affichée est le parent lui-même, on la remplace par la sous-rubrique trouvée
    if (lien && chemin(feuille.dataset.crumbTag) === chemin(parent.getAttribute("href")) && !feuille.hasAttribute("data-crumb-courant")) {
        const f = feuille.querySelector("a"); if (f) { f.href = lien.href; f.textContent = lien.textContent.trim(); }
        li.remove(); li.querySelector("a").href = parent.href; feuille.before(li);
    }
}

// Bouton « Haut de page » : visible après un écran de défilement
function hautDePage() {
    const b = document.getElementById("haut-de-page");
    if (!b) return;
    let visible = false;
    const maj = () => { const v = window.scrollY > window.innerHeight; if (v !== visible) { visible = v; b.hidden = !v; } };
    window.addEventListener("scroll", maj, { passive: true }); maj();
    b.addEventListener("click", () => { window.scrollTo({ top: 0 }); const cible = document.getElementById("contenu") || document.body; cible.setAttribute("tabindex", "-1"); cible.focus({ preventScroll: true }); });
}

export default function article() {
    filAriane();
    hautDePage();
    const corps = document.querySelector(".article-body");
    if (!corps) return;

    // Vignette de signet minuscule (favicon étirée par Ghost) : affichée à sa taille sur fond neutre
    corps.querySelectorAll(".kg-bookmark-thumbnail img").forEach((img) => {
        const petite = () => { if (img.naturalWidth && img.naturalWidth < 240) img.closest(".kg-bookmark-thumbnail").classList.add("vignette-petite"); };
        img.complete ? petite() : img.addEventListener("load", petite, { once: true });
    });

    // Sommaire (h2 et h3 du contenu, qui portent déjà un id posé par Ghost)
    const toc = document.getElementById("toc");
    const titres = [...corps.querySelectorAll("h2[id], h3[id]")].filter((h) => !h.closest(".kg-card, .commentaires") && h.textContent.trim());
    if (toc && titres.length >= 2) {
        const nav = toc.querySelector("nav");
        titres.forEach((h) => {
            const a = document.createElement("a");
            a.href = "#" + h.id;
            a.textContent = h.textContent.trim();
            if (h.tagName === "H3") a.className = "l3";
            nav.appendChild(a);
        });
        toc.hidden = false;
    }

    // Prochain rendez-vous : premier à venir
    const bloc = document.getElementById("prochain-rdv");
    if (bloc) {
        const maintenant = new Date();
        const prochain = [...bloc.querySelectorAll(".rdv")]
            .map((el) => ({ el, d: lire(el.dataset.date) }))
            .filter((x) => x.d && x.d >= maintenant)
            .sort((a, b) => a.d - b.d)[0];
        if (prochain) { prochain.el.hidden = false; bloc.hidden = false; }
    }

    // Accessibilité des cartes Ghost dont le HTML n'est pas modifiable (R3)
    corps.querySelectorAll(".kg-product-card-image:not([alt])").forEach((i) => i.setAttribute("alt", ""));
    const etiquettes = [[".kg-video-seek-slider, .kg-audio-seek-slider", "Position de lecture"], [".kg-video-volume-slider, .kg-audio-volume-slider", "Volume"]];
    etiquettes.forEach(([sel, nom]) => corps.querySelectorAll(sel).forEach((el) => { if (!el.getAttribute("aria-label")) el.setAttribute("aria-label", nom); }));
    // Titres h4 des cartes dépliant et produit (HTML Ghost) : niveau 3 pour les lecteurs d'écran, sous le h2 courant
    corps.querySelectorAll(".kg-toggle-heading-text, .kg-product-card-title").forEach((h) => { h.setAttribute("role", "heading"); h.setAttribute("aria-level", "3"); });
    corps.querySelectorAll("pre").forEach((pre) => { if (pre.scrollWidth > pre.clientWidth) { pre.tabIndex = 0; pre.setAttribute("aria-label", "Bloc de code, défilement horizontal"); } });
    // Tableaux plus larges que la colonne : défilables, donc atteignables au clavier (WCAG 2.1.1)
    corps.querySelectorAll("table").forEach((t) => { if (t.scrollWidth > t.clientWidth) { t.tabIndex = 0; if (!t.hasAttribute("aria-label") && !t.querySelector("caption")) t.setAttribute("aria-label", "Tableau, défilement horizontal"); } });

    // Partage
    const copier = document.querySelector("[data-copier]");
    if (copier && navigator.clipboard) {
        copier.addEventListener("click", async () => {
            try {
                await navigator.clipboard.writeText(copier.dataset.copier);
                copier.dataset.etat = "ok";
                copier.querySelector("span").textContent = "Lien copié";
                setTimeout(() => { delete copier.dataset.etat; copier.querySelector("span").textContent = "Copier le lien"; }, 2500);
            } catch (e) { /* presse-papiers indisponible */ }
        });
    }
    const imprimer = document.querySelector("[data-imprimer]");
    if (imprimer) imprimer.addEventListener("click", () => window.print());
}
